import { render, staticRenderFns } from "./UnitOfMeasureUnitSelector.vue?vue&type=template&id=240433b9"
import script from "./UnitOfMeasureUnitSelector.vue?vue&type=script&lang=js"
export * from "./UnitOfMeasureUnitSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports